"use client";

import { useState } from "react";
import { useTranslations } from "next-intl";
import { BookingModal } from "./BookingModal";

interface BookingButtonProps {
  mentorName: string;
  mentorId: string;
  className?: string;
}

export function BookingButton({ mentorName, mentorId, className }: BookingButtonProps) {
  const [open, setOpen] = useState(false);
  const t = useTranslations("profile");

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        className={`inline-flex items-center justify-center rounded-lg px-6 py-3 text-sm font-semibold text-white transition-opacity hover:opacity-90 ${className ?? "mt-8"}`}
        style={{ background: "var(--color-brand)" }}
      >
        {t("requestSession")}
      </button>

      {open && (
        <BookingModal
          mentorName={mentorName}
          mentorId={mentorId}
          onClose={() => setOpen(false)}
        />
      )}
    </>
  );
}
